export enum CreditReportType {
    Company = 'Company',
    Consumer = 'Consumer'
}
